module.exports = __webpack_public_path__ + "img/btn4-2.404ca3e9.png";